<template>
  <div>
    <v-tabs>
      <v-tab v-for="tab of tabs" :key="tab.id" :to="tab.route">
        {{ tab.name }}
      </v-tab>

      <v-tab-item>
        <router-view></router-view>
      </v-tab-item>
    </v-tabs>
  </div>
</template>



<script>
export default {
  data() {
    return {
      tabs: [
        { id: 1, name: "Home", route: '/' },
        { id: 2, name: "Country", route: '/Country' },
        { id: 3, name: "Traning", route: '/Traning' },
        { id: 4, name: "Achievement", route: '/Achievement'},
        { id: 5, name: "Experience", route: '/Experience'},
        { id: 6, name: "Knowledge", route: '/Knowledge'},
        { id: 7, name: "CreateEducation", route: '/CreateEducation'},
      ]
    };
  }
};
</script>

<style>
</style>